var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button } from "@mui/material";
import * as React from "react";
import { Fragment, useCallback } from "react";
import { useFlag, useIsMounted } from "../utils";
import { ConfirmDialog } from "./ConfirmDialog";
export function ConfirmButton(props) {
    const { fullWidth, title, confirmTitle, cancel, icon, children, onConfirm, color, variant, disabled, } = props;
    const isMounted = useIsMounted();
    const [dialogOpen, setDialogOpen, clearDialogOpen] = useFlag(false);
    const handleConfirm = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield onConfirm();
        if (isMounted) {
            clearDialogOpen();
        }
    }), [onConfirm, isMounted]);
    return (React.createElement(Fragment, null,
        React.createElement(Button, { onClick: setDialogOpen, color: color, variant: variant, disabled: disabled, startIcon: icon, fullWidth: fullWidth }, title),
        React.createElement(ConfirmDialog, { open: dialogOpen, onClose: clearDialogOpen, title: title, confirmTitle: confirmTitle, cancel: cancel, onConfirm: handleConfirm, color: color, fullWidth: fullWidth, icon: icon }, children)));
}
//# sourceMappingURL=ConfirmButton.js.map